var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zj_warp warp"},[_c('div',{staticClass:"widget_title"},[_c('span',{staticClass:"router_tag",on:{"click":_vm.routerPath}},[_vm._v("···")]),_vm._v(" "),_c('div',{staticClass:"cont_text_overflow"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("warp_header")],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de093738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/widget/zj_warp.vue
// module id = null
// module chunks = 